{
  "+/na8S": "在 {experienceLevel} 的職位空缺",
  "+RBfjK": "<strong>政府機關</strong>－在法律、法規或法律程序要求的情況下。",
  "+lsg50": "<strong>事務性溝通：</strong>發送申請狀態更新、面試提醒、入職說明以及其他與您的申請或就業直接相關的溝通訊息（根據您的同意選擇，透過簡訊、電子郵件或電話）。",
  "/GKTwV": "{startResult} - {endResult} 的 {totalCount}",
  "/SZPmm": "按職位名稱或關鍵字搜尋",
  "/pdLnE": "<strong>刪除權：</strong>您可以要求我們刪除您的個人信息，但須遵守某些法律例外情況（例如記錄保存義務）。",
  "00m1vT": "<strong>自動收集的資料：</strong>根據我們平台提供者的標準資料保留政策進行保留。",
  "06JQuf": "5. 免責聲明",
  "0uj8CA": "您可能符合資格的就業機會和職位（行銷）",
  "0xKvFl": "<strong>查閱權：</strong>您可以要求取得我們持有的關於您的個人資訊的副本。",
  "1MNiI4": "選擇 {name}",
  "1QOHHT": "工作時間",
  "1WIMxg": "取消",
  "1ma4gO": "當您與我們的招募網站互動時，我們可能會收集以下幾類個人資訊：",
  "2YzWOm": "申請",
  "2gDsJ9": "請調整您的搜尋和篩選條件。",
  "2ysiB3": "清除所有篩選條件",
  "3CLJU9": "請透過以下方式與我們聯絡：<supportLink> {supportContact}</supportLink>",
  "3NW9w+": "{accountName} 隱私權政策",
  "3RG7Do": "6.你的權利和選擇",
  "3Yr6Zd": "1. 本網站的使用",
  "3oHMyk": "根據您所在地區，您可能擁有以下關於個人資訊的權利：",
  "3qpbhl": "10. 資料安全",
  "3v8etI": "在 {position} 的職位空缺",
  "41OEjv": "我們會直接從您收集個人資訊（透過申請表），並透過我們的平台提供者的技術自動收集個人資訊（透過嵌入我們招募網站的 cookie 和類似技術）。",
  "4ohioF": "<strong>平台營運：</strong>我們授權平台提供者（Fountain）代表我們維護招募網站的安全性和功能，包括偵測詐欺行為和解決技術問題。",
  "56kYFg": "<strong>與申請相關的簡訊：</strong>狀態更新、面試提醒、入職說明以及其他與您的申請或在{accountName}工作直接相關的訊息。<em>（交易型）</em>",
  "5c0xwM": "選擇退出後，您將收到一封確認訊息。您可以透過招聘網站重新註冊，或回覆我們的任何訊息發送簡訊「START」來重新訂閱。",
  "6I7QkP": "當地的",
  "6gJsj3": "隱私政策",
  "7EUdCR": "當您透過我們的招聘網站提交申請時，您的個人資訊將由我們的平台提供者（Fountain）代表我們直接收集。我們也可能與以下幾類服務提供者分享您的個人訊息，以協助我們進行招募流程：",
  "7HOdgz": "找不到 ({location}) 附近的職缺",
  "7K2KnA": "過濾器",
  "7O1CGZ": "如果您對本隱私權政策有任何疑問或希望行使您的任何權利，請與我們聯絡：",
  "7srJEb": "在 {brandName} 尋找你的下一個機會",
  "8R2FQ7": "申請",
  "8YcgIg": "/年",
  "8lJb89": "生效日期：2026年4月",
  "8moA7E": "在我們的申請表上勾選選擇加入框，即表示您同意接收來自 {accountName} 的短信，發送至您提供的電話號碼。資訊可能包含：",
  "9Jg0WQ": "排序方式",
  "9TzuJX": "職缺",
  "9ZVuvw": "<supportLink>{supportContact}</supportLink>",
  "9fotW7": "如何選擇退出：",
  "9gvBvK": "職位類型",
  "A939ot": "清除",
  "AEkpsv": "永恆的",
  "AXM0Ru": "隱私政策",
  "Af+l/5": "{count, plural, other {現有{count,number}個職位空缺}}",
  "AkOXuk": "<strong>設備和使用資料：</strong> IP 位址、瀏覽器類型、裝置識別碼、作業系統以及根據您的 IP 位址推斷出的大致位置",
  "Apa4NB": "11. 兒童隱私",
  "BwwT2Q": "<strong>互動資料：</strong>您在我們招募網站上造訪的頁面、停留時間以及在申請過程中採取的操作。",
  "C/40b0": "職位",
  "C5OA4b": "一旦您的個人資訊不再需要用於上述任何目的，我們將與我們的平台提供者協調，根據適用的資料保留和處置程序安全地刪除或匿名化您的個人資訊。",
  "CIaoJm": "員工登入",
  "CfEcpR": "<strong>不受歧視的權利：</strong>我們不會因為您行使任何隱私權而對您進行歧視。",
  "DTxAgM": "<strong>知情權：</strong>您可以要求獲取有關我們收集的關於您的個人資訊的類別和具體內容、該資訊的來源、收集目的以及我們與之共享該資訊的第三方類別的資訊。",
  "DaFtVe": "<strong>背景調查提供者</strong>－如果您在招募過程中進入下一階段並提供單獨的同意，我們可能會與第三方提供者分享資訊以進行背景調查。",
  "E+ZmsH": "我們的招聘網站由我們的平台提供者（Fountain）經營，使用 cookie 和類似技術來收集第 2 節中所述的設備和使用資料。這些技術由 Fountain 代表我們部署，用於營運招聘網站、分析使用情況和提高效能。有關我們招聘網站上使用的特定 Cookie 的詳細信息，請參閱 Fountain 的隱私權政策。<fountainPrivacyLink> fountain.com/privacy</fountainPrivacyLink> 。",
  "E2+MeX": "<strong>請勿追蹤訊號：</strong>我們的招聘網站目前不回應「請勿追蹤」（DNT）瀏覽器訊號。目前，對於識別或回應 DNT 訊號，業界還沒有統一的標準。",
  "ECDDUw": "如果您選擇退出，我們將立即處理您的請求。選擇不接收行銷訊息不會影響與有效申請或僱傭關係相關的交易訊息，除非您單獨選擇不接收這些訊息。",
  "EJyETf": "在申請過程中，您可能會被要求對以下每種溝通方式分別提供同意：",
  "EZ7l60": "選擇距離",
  "F4rSq/": "<strong>訊息頻率：</strong>訊息頻率根據您的應用程式狀態和活動而有所不同。可能適用標準簡訊和數據流量費用。",
  "FD+Ak4": "過濾器",
  "FbMyuc": "<strong>短信同意記錄：</strong>如果您選擇接收短信，我們會收集並保留您的同意記錄。",
  "Fza3xO": "{count, plural, other {{query}（所有地點）共有 {count,number} 個職缺}}",
  "G3uSr3": "排序方式：",
  "GLUAB+": "在 {category} 的職位空缺",
  "GiGPOp": "<strong>處理您的申請：</strong>評估您的資格、安排面試、進行背景調查（必要時需徵得您的同意）以及與您溝通您的申請狀態",
  "GnfGtK": "我們建議您定期查看此政策。您在變更發布後繼續使用我們的招聘網站並不代表您同意修訂後的條款—任何需要您同意的處理都將受單獨的同意機制約束。",
  "GoyAbs": "「{query}」的搜尋結果",
  "Gx/VZ8": "全職",
  "HjtQ1S": "<strong>我們不會出售您的個人資訊。我們也不會將您的個人資訊用於跨平台行為廣告。</strong>",
  "IPBVH3": "9. Cookie、追蹤技術和“請勿追蹤”",
  "J4l/AQ": "行政及專業",
  "J8cmAm": "顯示更多 ({count})",
  "JC1ICT": "補償類型",
  "Jlcabf": "<strong>敏感個人資訊：</strong>根據職位和適用法律，我們可能會收集政府頒發的身份識別號碼（例如社會安全號碼或駕駛執照號碼）以用於就業核實或背景調查。我們僅出於法律允許的特定目的處理敏感個人訊息，不會將其用於使用者畫像或廣告宣傳。加州居民有權限制我們對敏感個人資訊的使用—請參閱第 6 節。",
  "JtmXU+": "搜尋 {name}",
  "KDjhll": "當我們從歐盟/歐洲經濟區或英國向美國傳輸個人資訊時，我們依賴以下保障措施：（a）歐盟-美國資料隱私框架（DPF）（如適用）；和/或（b）經歐盟委員會批准的標準合約條款（SCC），這些條款已納入我們與服務提供者的資料處理協議中。您可以聯絡我們索取適用保障措施的副本。<supportLink> {supportContact}</supportLink> 。",
  "KrXS5/": "回覆我們發送的任何簡訊「STOP」即可取消訂閱。",
  "L1t2kd": "訊息發送頻率不固定。可能產生簡訊和數據流量費用。",
  "LOXUJb": "使用的 Cookie 類型：",
  "Lbwy5v": "職位名稱",
  "LtyZus": "<strong>求職簡訊：</strong>提供您可能符合資格的其他{accountName}職位資訊。<em>（行銷－需單獨選擇加入）</em>",
  "MCzo6Q": "<strong>工作機會電話：</strong>關於您可能符合資格的其他{accountName}職位的電話。<em>（行銷－需單獨選擇加入）</em>",
  "Mf37lr": "熱門類別",
  "Mh1F+e": "{count, plural, other {找到 {count,number} 個遠距工作崗位}}",
  "NG6g7y": "半徑",
  "Nkxa4f": "所有服務提供者均有合約義務保護您的訊息，僅將其用於我們指定的用途，並且不得將其保留超過提供服務所必需的時間。",
  "OpSpNa": "我們會將您的個人資訊保留至合理必要的期限，以實現收集該資訊的目的，包括提供您所要求的服務、處理和評估您的申請、支持任何由此產生的僱傭關係、履行我們的法律和監管義務以及解決爭議。",
  "OuE0df": "<strong>選擇退出出售/共享的權利：</strong>我們不會出售或分享您的個人資訊以用於跨情境行為廣告。無需選擇退出，因為我們不參與這些行為。",
  "OxK884": "財務與會計",
  "PkU5jD": "<strong>所有管道：</strong>聯絡方式<supportLink>{supportContact}</supportLink>更新或撤銷您在所有通訊管道中的同意偏好。",
  "Q43kt/": "<strong>與申請相關的電話：</strong>關於您的申請狀態、面試安排和入職的電話。<em>（交易型）</em>",
  "QHXX/I": "<strong>通訊服務提供者</strong>－電話業者和簡訊服務供應商，用於發送簡訊和撥打電話。我們可能會與幫助我們提供簡訊服務的第三方共享您的個人數據，包括您的簡訊選擇加入或同意狀態，包括但不限於平台提供者、電話公司以及協助發送簡訊的任何其他供應商。這種共享僅用於提供服務的目的。",
  "Qc+F6I": "每一項同意選擇都是<strong>獨立的</strong>。您可以選擇接收其中任何一種、全部或不接收任何類型的通訊資訊。您的選擇不會影響您的申請。",
  "Qjh8MV": "<strong>如何獲得協助：</strong>回覆任一簡訊<strong>「HELP」</strong>即可獲得協助，或聯絡我們。<supportLink> {supportContact}</supportLink> 。",
  "QmFp6b": "<strong>Fountain, Inc</strong> .——我們的招募平台提供者。Fountain 代表我們收集和處理您的個人訊息，以方便申請流程、發送簡訊和其他通訊以及管理招聘工作流程。Fountain 的隱私權政策可在以下網址檢視：<fountainPrivacyLink> fountain.com/privacy</fountainPrivacyLink> 。",
  "R+laqn": "類別",
  "R5pOCA": "請查看以下 {brandName} 的所有可用職缺，或搜尋其他地點的職缺。",
  "RdNN/i": "任何",
  "RhRgl7": "<strong>更正權：</strong>您可以要求我們更正不準確的個人資訊。",
  "RwsNjX": "2. 簡訊服務",
  "ShbUPK": "城市",
  "T0z9P/": "{count, plural, other {在 {radius} {unit} 中找出 {count,number} 個職位，共 {location} 個職位}}",
  "TBEZ9x": "職缺名稱",
  "TuoZCm": "尋找您的下一個機會",
  "UKI/HU": "全部",
  "Ud728E": "在適用法律允許的最大範圍內，{accountName} 對您使用本網站或我們的簡訊服務而引起的任何間接、附帶、特殊或後果性損害不承擔任何責任。",
  "V/osST": "目前位置",
  "VC3i9i": "本網站及其內容均以「現況」提供，不提供任何形式的明示或暗示的保證。我們不保證網站不會中斷或發生錯誤。",
  "VcjP63": "您的個人資訊可能會傳輸到美國並在美國處理，因為我們的平台供應商 Fountain 在美國經營其主要基礎設施。美國可能無法提供與您所在國家/地區相同程度的資料保護。",
  "VguvIP": "{count, plural, other {有 {count,number} 個職位空缺，面向 {query}}}",
  "VoPWLM": "搜尋類別",
  "Vvd1rH": "我們可能會定期更新這些條款。條款變更發布後，您繼續使用本網站即表示您接受修訂後的條款。",
  "WT6YVK": "前一個",
  "WjwoSF": "<strong>簡訊同意記錄：</strong>為遵守監管規定，至少保留五 (5) 年，符合營運商和 FCC 的記錄保存要求。",
  "WuHcvG": "我們的招聘網站由<strong>Fountain, Inc.</strong> （「Fountain」）提供技術支持，Fountain 是一個勞動力管理平台，作為我們的服務提供者，代表我們處理您的個人資訊。Fountain 作為資料處理者；我們是資料控制者，負責決定如何以及為什麼處理您的個人資訊。",
  "X1Y9Ps": "按開場名稱搜尋",
  "XPamEN": "/小時",
  "XcuBSu": "所有可用職缺",
  "XjSvOF": "營運與領導力",
  "YDhGHb": "7. 資料保留",
  "YQbDhN": "服務條款",
  "YbL2yB": "<strong>就業資訊：</strong>工作經驗、教育背景、技能、證書以及申請問題的回答",
  "Yoy6Jy": "請查看以下 {brandName} 的所有可用職缺，或搜尋其他地點的職缺。",
  "Z4YDPm": "<strong>申請資料：</strong>如果您被錄用，您的申請資料將在僱傭關係存續期間以及此後一段合理的時間內保留，具體保留期限根據適用的僱傭、稅務和記錄保存法律的要求而定。如果您未被錄用，您的申請資料通常會保留一段時間，以便考慮未來的就業機會並遵守法律法規要求，除非法律要求更短或更長的保留期限。",
  "a37+C1": "申請狀態更新、入職資訊和其他與就業相關的通知（事務性）",
  "aD7/QV": "兼職",
  "aKWnwv": "頁面",
  "aaT0rw": "當您造訪我們的招募網站時，我們的平台提供者（Fountain）會代表我們自動使用 cookie 和類似技術收集某些資訊。這可能包括：",
  "avRBAo": "發布日期",
  "bQxKXO": "遠端",
  "c0TwrW": "按開業名稱或地點搜尋",
  "cP462m": "{count, plural, other {現有{count,number}個職缺（所有地點）}}",
  "cScov5": "<strong>簡訊：</strong>回覆<strong>「STOP」</strong>即可停止發送任何簡訊。回覆「停止」即可取消接收該號碼所發送的<strong>所有簡訊</strong>。如果您只想選擇退出某一類簡訊（例如，行銷簡訊但不包含交易簡訊），請聯絡我們。<supportLink> {supportContact}</supportLink>以細粒度方式更新您的偏好設定。",
  "ccduZH": "<strong>歐盟/歐洲經濟區/英國申請人：</strong>根據電子隱私指令（指令 2002/58/EC）或英國隱私和電子通訊條例（PECR）的要求，我們將在放置非必要 cookie 之前徵得您的同意。您可以透過瀏覽器設定管理您的 Cookie 偏好設定。",
  "cnNa4F": "由於您的個人資訊是透過我們的平台提供者（Fountain）處理的，我們可能會與 Fountain 協調以滿足您的請求。這不會影響您直接向我們提交請求的權利，我們仍有責任在適用法律規定的時間內回覆您。",
  "coNrE4": "<strong>來電：</strong>請告知來電者您希望被移除，或聯絡我們。<supportLink> {supportContact}</supportLink> 。",
  "ctMrd+": "<strong>任何行動資訊（包括手機號碼和簡訊選擇加入或同意資料）不會分享給第三方或關聯公司用於其行銷或推廣目的。</strong>除簡訊發送者選擇加入資料和同意外，所有其他類別均不包含此類資訊；此類資訊不會與任何第三方共用。",
  "dHKLYk": "與我們聊天",
  "dINcE1": "搜尋職位",
  "dMBRRH": "內部招募網站",
  "dSrjr/": "本隱私權政策描述了當您透過我們的招聘網站申請職位時， <strong>{accountName}</strong> （「我們」）如何收集、使用和保護您的個人資訊。",
  "eN7CVI": "8. 這些條款的變更",
  "ePJ10M": "距離",
  "eWWpS5": "穿梭",
  "ejsFwD": "6. 責任限制",
  "eoLsYT": "未找到工作",
  "epJ7rX": "1. 我們是誰",
  "esYqDb": "13. 聯絡我們",
  "f5ZXVy": "本條款受特拉華州法律管轄並依其解釋，不考慮其衝突法條款。因本條款引起的任何爭議應由位於特拉華州的州法院和聯邦法院專屬管轄。",
  "f5xlBv": "{count, plural, other {在 {location} 附近找到 {count,number} 個工作崗位}}",
  "f9XZvs": "服務條款",
  "fHwoN4": "<strong>任何行動資訊（包括手機號碼、簡訊選擇加入狀態和同意資料）均不會被分享、出售或出租給第三方或關聯公司用於其行銷或推廣目的。</strong>行動端選擇加入和同意資訊僅與通訊服務提供者（例如營運商和訊息平台供應商）共享，且僅限於向您發送所要求的訊息所必需的情況，不會用於任何第三方的獨立行銷用途。",
  "fqbMOd": "位置",
  "fz8Tvp": "<strong>絕對必要的 cookie：</strong>招募網站運作所必需的（例如，會話管理、安全）。這些功能無法停用。",
  "gKKaX9": "同意接收簡訊並非申請或獲得工作的條件。",
  "ggOC46": "如果您對 Fountain 平台如何處理您的資料有任何疑問，您也可以聯絡 Fountain 的隱私團隊：<privacyMailLink> privacy@fountain.com</privacyMailLink>",
  "h8XXuO": "5. 我們如何分享您的訊息",
  "hCJFEI": "8. 對於歐盟/歐洲經濟區/英國申請人：國際資料傳輸",
  "hNt7Xn": "搜尋",
  "hph9/b": "3. 我們如何使用您的訊息",
  "iVSyX5": "任何",
  "iwEvY/": "<strong>識別資訊：</strong>姓名、電子郵件地址、電話號碼、郵寄地址",
  "jPYzxK": "2. 我們收集的資訊",
  "jW9g8Q": "/月",
  "jjNqku": "選擇位置",
  "kDYV94": "遠距辦公、在家工作、居家辦公、遠距通勤",
  "kFJ1hG": "清除",
  "ki+WBr": "/天",
  "kkx0Di": "{count, plural, other {找出 {count,number} 個遠距工作機會 {query}}}",
  "lDKw0M": "<strong>入職：</strong>如果您獲得職位，我們將協助您完成入職流程，包括收集文件、安排培訓和入職培訓。",
  "lwRtGv": "搜尋位置",
  "mOqk1N": "<strong>限制使用敏感個人資訊的權利：</strong>如果我們收集敏感個人資訊（例如社會安全號碼或政府頒發的身份證），您有權限制我們僅將該資訊用於提供您合理期望的服務所需的目的。如需行使此項權利，請聯絡我們。<supportLink> {supportContact}</supportLink> 。",
  "mqm7rH": "<strong>分析型 Cookie：</strong>幫助我們了解求職者如何與招募網站互動。這些數據可能由第三方分析服務提供者提供。",
  "mvv/A1": "您附近的職缺 {location}",
  "n/WRpL": "找不到 {location} 附近的職缺",
  "n4YEE0": "清除",
  "nUNDHI": "我們會採取合理措施確保您的個人資訊受到保護。由於您的資料是透過我們的平台提供者（Fountain）處理的，因此我們依賴 Fountain 的技術和組織安全控制，其中包括 SOC 2 II 型認證、ISO 27001:2022 認證以及傳輸中資料（TLS 1.2+）和靜態資料（AES-256）的加密。我們與 Fountain 簽訂了資料處理協議，該協議要求 Fountain 採取適當的安全措施來保護您的個人資訊。",
  "nUYXYf": "合約工/自由工作者",
  "nrL6lE": "看更多 ({count})",
  "ntF3q4": "<strong>授權代理人：</strong>您可以指定一名授權代理人代表您提交隱私請求。代理人必須提供您的授權證明（例如簽署的書面許可或授權委託書），我們可能仍會要求您直接驗證您的身分。",
  "nxt8Qc": "選擇類別",
  "o5G5gO": "按位置搜尋",
  "o5Lr3P": "<strong>法律合規：</strong>履行我們的法律義務，包括記錄保存、稅務申報、就業資格核實以及回應政府機構的合法要求。",
  "oV4vX7": "可用職缺",
  "oojjh4": "使用由 {accountName}（「我們」、「我們的」）所經營的網站，即表示您同意本服務條款。",
  "pCgcIl": "我們使用您的個人資訊用於以下目的：",
  "pXg8OU": "<strong>行銷訊息：</strong>如果您單獨選擇接收，我們將向您發送有關您可能符合資格的其他工作機會的資訊。",
  "pfzWdN": "隨意的",
  "pjY7EJ": "<strong>文件：</strong>履歷、政府核發的身份證明（如工作需要核實身分），以及您在申請或入職過程中上傳的其他文件。",
  "poL3TM": "電子郵件：<supportLink> {supportContact}</supportLink>",
  "puJXDp": "3. 如何獲得協助",
  "qt4wYG": "{accountName} 隱私權政策",
  "r1QaDh": "沒有任何一種傳輸或儲存方法是完全安全的。雖然我們盡力保護您的個人訊息，但我們無法保證絕對安全。",
  "r7Kb/z": "無可用選項",
  "rUGq0i": "國家/地區",
  "rdOcXL": "登出",
  "rth6q8": "過濾器",
  "s0o3E7": "搜尋在 {brandName} 的職缺",
  "sEzBNV": "<strong>是否同意接收簡訊或電話完全出於自願，並非提交求職申請或獲得工作的條件。</strong>如果您選擇不接收我們的郵件，我們可能會透過電子郵件與您聯絡。",
  "sR3x84": "學員",
  "sox8LY": "我們可能會不時更新本隱私權政策。如果我們對處理您的個人資訊的方式做出重大改變，我們將：(a) 在我們的招聘網站上發布醒目的通知，以及 (b) 在可行的情況下，透過存檔的聯絡資訊通知已提交有效申請的申請人。更新後的政策將註明修訂後的生效日期。",
  "stlhl5": "<strong>加州居民：</strong>根據經《加州隱私權法案》（CCPA/CPRA）修訂的《加州消費者隱私法案》，您享有上述所有權利。如需提交可驗證的消費者請求，請聯絡我們：<supportLink> {supportContact}</supportLink> 。我們將在滿足您的請求之前核實您的身份，並按照法律規定在 45 天內作出答复。",
  "syNys9": "{count, plural, other {在 {radius} {unit} 中找出 {count,number} 個與 {query} 相關的職位，共 {location} 個職位。}}",
  "tIQhbD": "客戶服務與營運",
  "tXdMLm": "我們的招募網站不針對16歲以下人士。我們不會故意收集16歲以下兒童的個人資訊。如果您認為我們收集了兒童的信息，請聯絡我們：<supportLink> {supportContact}</supportLink>這樣我們就可以及時刪除它。",
  "tYpw2s": "({location})附近的職缺",
  "tbs+f9": "{accountName} 隱私權政策與使用條款",
  "tdTJ7T": "4. 如何選擇退出",
  "toqXyd": "服務條款",
  "tsGjFK": "英哩",
  "uMkyWa": "您直接提供的資訊：",
  "uq79O0": "地點名稱",
  "uy6hZs": "州/省",
  "w3RZCZ": "工作機會",
  "w7EwgX": "12. 本隱私權政策的變更",
  "wWh0//": "{count, plural, other {在 {location} 附近找到 {count,number} 個與 {query} 相關的職位}}",
  "wdw5oL": "9. 聯絡我們",
  "wqAadg": "區域",
  "x+3jJQ": "公里",
  "xUezuu": "保留期限取決於我們平台提供者（Fountain）的功能和配置。如果您對具體的保留期限有任何疑問，請與我們聯絡。<supportLink> {supportContact}</supportLink> 。",
  "xbL6qz": "7. 適用法律",
  "xgBjTg": "資訊科技",
  "yIC7Pq": "的{lastPage}",
  "yJcC0I": "4. 簡訊和電話通訊計劃",
  "yfcesY": "透過我們的平台提供者自動收集的資訊：",
  "zBwVKO": "遠端",
  "zKRBxT": "本網站由 {accountName} 經營，旨在方便求職申請和與就業相關的溝通。您同意僅出於合法目的並按照本條款使用本網站。",
  "zPvAKV": "臨時",
  "zabbLE": "下"
}
